import _ from 'lodash';
import { EntityCode, PolicyListRes, PolicyStatus } from '../types';

/**
 * Policy List Sorting
 */
const statusOrder: Record<PolicyStatus, number> = {
  overdue: 1,
  dueSoon: 2,
  processing: 3,
  inforce: 4,
  matured: 5,
  inactive: 6,
  lapsed: 7,
};

const effectiveDateSortedEntityCodes: EntityCode[] = ['LHK', 'LMA', 'G4HK'];
const expirationDateSortedEntityCodes: EntityCode[] = ['GHK'];

const getDisplayDateValue = (dateValue: string | null) => {
  const parsedValue = dateValue ? Number(dateValue) : NaN;
  return Number.isNaN(parsedValue) ? null : parsedValue;
};

const getDisplayDateSortValue = (
  dateValue: string | null,
  fallbackValue: number,
) => {
  const value = getDisplayDateValue(dateValue);
  return value === null ? fallbackValue : value;
};

const getEffectiveDateSortValue = (policy: PolicyListRes) => {
  const entityCode = policy.policy?.entityCode;

  return effectiveDateSortedEntityCodes.includes(entityCode)
    ? getDisplayDateSortValue(
        policy.policy?.policyEffectiveDateForDisplay,
        -Infinity,
      )
    : -Infinity;
};

const getExpirationDateSortValue = (policy: PolicyListRes) => {
  const entityCode = policy.policy?.entityCode;

  return expirationDateSortedEntityCodes.includes(entityCode)
    ? getDisplayDateSortValue(
        policy.policy?.policyExpirationDateForDisplay,
        Infinity,
      )
    : Infinity;
};

export function sortPolicies(policies: PolicyListRes[]) {
  return _.orderBy(
    policies,
    [
      (policy) => statusOrder[policy.policy?.policyStatus] || 999,
      getEffectiveDateSortValue, // latest to oldest
      getExpirationDateSortValue, // closest to farthest
    ],
    ['asc', 'desc', 'asc'],
  );
}

/**
 * Policy List Filtering
 */
export function isFilteredPolicy(
  policy: PolicyListRes['policy'],
  filteringStatus: PolicyStatus[] = [],
) {
  let isMatchedStatus = true;
  const policyStatus = policy?.policyStatus;

  if (filteringStatus && filteringStatus.length > 0) {
    isMatchedStatus = filteringStatus.includes(policyStatus);
  }

  return isMatchedStatus;
}
